import { getReceipts } from "../services/Rest.jsx";
import useFetch from "./useFetch.jsx";

const useReceipts = (autoFetch = false, filter = null) => {
  return useFetch(getReceipts, autoFetch, filter);
};

export default useReceipts;
